export const regex = {
  apiSuccess: /20[01]/,
  email: /^(?!.*(?:''|\.\.))[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/,
};
